/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Resolve transfer request
 */
export interface ResolveTransferRequestDto {
  transferId: number;
  /**
   * Resolve type.
   */
  resolveType: ResolveTransferRequestDto.ResolveTypeEnum;
  /**
   * Transaction hash for settled outside case.
   */
  txHash?: string;
  /**
   * Note for client.
   */
  clientNote?: string;
  /**
   * Note for admin.
   */
  adminNote?: string;
  /**
   * Additional part for system note.
   */
  systemNote?: string;
  /**
   * Specific ID of fireblocks user.
   */
  fireblocksUserId?: string;
}
export namespace ResolveTransferRequestDto {
  export const ResolveTypeEnum = {
    Error: 'ERROR',
    ForceSettleFireblocks: 'FORCE_SETTLE_FIREBLOCKS',
    SettledOutside: 'SETTLED_OUTSIDE',
    GoldenCatch: 'GOLDEN_CATCH',
    RevertGoldenCatch: 'REVERT_GOLDEN_CATCH',
  } as const;
  export type ResolveTypeEnum = (typeof ResolveTypeEnum)[keyof typeof ResolveTypeEnum];
}
